export const CAT_HOMEPAGE = "CATALOGUE_HOMEPAGE";
export const CAT_ADV_BAL_INV = "CATALOGUE_ADVANCE_BALANCE_INVOICE";
export const CAT_GIFT_CARD_INV = "CATALOGUE_GIFT_CARD_INVOICE";
export const CAT_MEM_INV = "CATALOGUE_MEMBERSHIP_INVOICE";
export const CAT_ORDER_CONFIRMATION = "CATALOGUE_ORDER_CONFIRMATION";
export const CAT_PACKAGE_INV = "CATALOGUE_PACKAGE_INVOICE";
export const CAT_PAYMENT_INV = "CATALOGUE_PAYMENT_INVOICE";
